"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
const TableColumnCell = _ref => {
  let {
    children
  } = _ref;
  if ((0, _ark.isUndefined)(children)) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};
TableColumnCell.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.func
};
TableColumnCell.defaultProps = {
  className: undefined,
  children: undefined
};
TableColumnCell.displayName = 'TableColumnCell';
var _default = exports.default = TableColumnCell;